/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  GetUserListApiV1WebpushNotificationsListGetQueryResponse,
  GetUserListApiV1WebpushNotificationsListGetHeaderParams,
  GetUserListApiV1WebpushNotificationsListGet422,
} from '../../types/GetUserListApiV1WebpushNotificationsListGet.ts'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getUserListApiV1WebpushNotificationsListGetQueryKey = () => [{ url: '/api/v1/webpush_notifications/list/' }] as const

export type GetUserListApiV1WebpushNotificationsListGetQueryKey = ReturnType<typeof getUserListApiV1WebpushNotificationsListGetQueryKey>

/**
 * @summary Get User List
 * {@link /api/v1/webpush_notifications/list/}
 */
export async function getUserListApiV1WebpushNotificationsListGet(
  headers?: GetUserListApiV1WebpushNotificationsListGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetUserListApiV1WebpushNotificationsListGetQueryResponse,
    ResponseErrorConfig<GetUserListApiV1WebpushNotificationsListGet422>,
    unknown
  >({ method: 'GET', url: `/api/v1/webpush_notifications/list/`, ...requestConfig, headers: { ...headers, ...requestConfig.headers } })
  return res.data
}

export function getUserListApiV1WebpushNotificationsListGetQueryOptions(
  headers?: GetUserListApiV1WebpushNotificationsListGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getUserListApiV1WebpushNotificationsListGetQueryKey()
  return queryOptions<
    GetUserListApiV1WebpushNotificationsListGetQueryResponse,
    ResponseErrorConfig<GetUserListApiV1WebpushNotificationsListGet422>,
    GetUserListApiV1WebpushNotificationsListGetQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getUserListApiV1WebpushNotificationsListGet(headers, config)
    },
  })
}

/**
 * @summary Get User List
 * {@link /api/v1/webpush_notifications/list/}
 */
export function useGetUserListApiV1WebpushNotificationsListGet<
  TData = GetUserListApiV1WebpushNotificationsListGetQueryResponse,
  TQueryData = GetUserListApiV1WebpushNotificationsListGetQueryResponse,
  TQueryKey extends QueryKey = GetUserListApiV1WebpushNotificationsListGetQueryKey,
>(
  headers?: GetUserListApiV1WebpushNotificationsListGetHeaderParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetUserListApiV1WebpushNotificationsListGetQueryResponse,
        ResponseErrorConfig<GetUserListApiV1WebpushNotificationsListGet422>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? getUserListApiV1WebpushNotificationsListGetQueryKey()

  const query = useQuery(
    {
      ...getUserListApiV1WebpushNotificationsListGetQueryOptions(headers, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetUserListApiV1WebpushNotificationsListGet422>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}